import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Crown, Share2 } from "lucide-react";
import api from "@/lib/api";

const MONTHS = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

export default function PilotOfMonth() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/pilot-of-the-month").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.pilot) return null;
  const p = data.pilot;
  const [y, m] = (data.month || "").split("-");
  const monthLabel = m ? `${MONTHS[parseInt(m, 10) - 1]} ${y}` : "";

  const share = async () => {
    const W = 1080, H = 1080;
    const c = document.createElement("canvas");
    c.width = W; c.height = H;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#09090b"; ctx.fillRect(0, 0, W, H);
    // decorative diagonals
    ctx.save();
    ctx.globalAlpha = 0.08;
    ctx.fillStyle = "#facc15";
    for (let i = -2; i < 14; i++) { ctx.fillRect(i * 90, 0, 34, H); }
    ctx.restore();
    ctx.fillStyle = "#facc15"; ctx.fillRect(0, 0, W, 12);
    ctx.fillStyle = "#facc15"; ctx.fillRect(0, H - 12, W, 12);

    const logo = new Image();
    logo.src = "/team-tuono-logo.png";
    await new Promise((res) => { logo.onload = res; logo.onerror = res; });
    if (logo.complete && logo.naturalWidth) { try { ctx.drawImage(logo, W - 188, 56, 132, 132); } catch (e) { /* skip */ } }

    ctx.textAlign = "left";
    ctx.fillStyle = "#facc15"; ctx.font = "bold 30px Arial"; ctx.fillText("TEAM TUONO", 64, 110);
    ctx.fillStyle = "#fafafa"; ctx.font = "900 76px Arial"; ctx.fillText("PILOTA DEL MESE", 64, 210);
    ctx.fillStyle = "#a1a1aa"; ctx.font = "34px Arial"; ctx.fillText(monthLabel.toUpperCase(), 64, 262);

    // crown
    ctx.textAlign = "center";
    ctx.font = "160px Arial"; ctx.fillText("\u{1F451}", W / 2, 470);

    ctx.fillStyle = "#facc15"; ctx.font = "900 116px Arial";
    ctx.fillText((p.name || "").toUpperCase().slice(0, 14), W / 2, 640);

    ctx.fillStyle = "#fafafa"; ctx.font = "bold 60px Arial";
    ctx.fillText(`${p.points} PUNTI`, W / 2, 760);
    ctx.fillStyle = "#06b6d4"; ctx.font = "bold 40px Arial";
    ctx.fillText(`${p.wins} vittorie \u00B7 ${p.races} gare`, W / 2, 830);

    const blob = await new Promise((res) => c.toBlob(res, "image/png"));
    const file = new File([blob], "pilota-del-mese.png", { type: "image/png" });
    try {
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: "Pilota del Mese", text: `Pilota del Mese: ${p.name} — Team Tuono` });
        return;
      }
    } catch (e) { /* fallback to download */ }
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "pilota-del-mese.png"; a.click();
    URL.revokeObjectURL(url);
    toast.success("Locandina generata");
  };

  return (
    <div data-testid="pilot-of-month" className="mb-8 flex flex-col sm:flex-row items-center gap-4 border border-yellow-400/40 bg-gradient-to-r from-yellow-400/10 via-zinc-900 to-zinc-900 p-5">
      <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-yellow-400/20 border border-yellow-400/50">
        <Crown className="h-7 w-7 text-yellow-400" />
      </div>
      <div className="min-w-0 flex-1 text-center sm:text-left">
        <div className="text-[10px] font-bold tracking-[0.25em] uppercase text-yellow-300/80">Pilota del Mese · {monthLabel}</div>
        <div className="font-heading text-2xl font-black uppercase text-zinc-50 truncate" data-testid="pilot-of-month-name">{p.name}</div>
        <div className="text-sm text-zinc-400">{p.points} punti · {p.wins} vittorie · {p.races} gare</div>
      </div>
      <button onClick={share} data-testid="share-pilot-of-month"
        className="inline-flex items-center gap-2 bg-yellow-400 text-zinc-950 font-bold text-xs tracking-[0.15em] uppercase px-5 py-3 hover:bg-yellow-300 transition-colors duration-200">
        <Share2 className="h-4 w-4" /> Condividi locandina
      </button>
    </div>
  );
}
